<template>
  <a
    v-if="url"
    class="meeting-join"
    :class="isTeams ? 'meeting-join--teams' : 'meeting-join--meet'"
    :href="url"
    target="_blank"
    rel="noopener"
  >
    <vs-icon icon="videocam" />{{ label }}
  </a>
</template>

<script>
import { meetingJoinUrl, meetingJoinLabel } from "@/utils/meetingJoin";

// Botão da chamada (Teams ou Meet) no card de reunião. Some quando a reunião foi
// recusada ou não tem sala online.
export default {
  name: "MeetingJoinLink",
  props: {
    meeting: { type: Object, default: null },
  },
  computed: {
    url() {
      if (!this.meeting || Number(this.meeting.meeting_status_id) === 2) return null;
      return meetingJoinUrl(this.meeting);
    },
    label() {
      return meetingJoinLabel(this.meeting);
    },
    isTeams() {
      return this.meeting && this.meeting.conference_provider === "teams";
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting-join {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border-radius: 999px;
  text-decoration: none;

  &--teams {
    background: #5b5fc7;
  }
  &--meet {
    background: #00897b;
  }

  .vs-icon {
    font-size: 18px;
  }
}
</style>
